module.exports = __webpack_public_path__ + "static/media/Academics.ec06dfd8.jpg";